@if (!isVisibleDeepLinkMsg) {
  <div class="ngx-data-table__warning-block">
    {{errorText}}<br>
    @if (actionableText) {
      <button type="button" class="cfa-plain-button cfa-plain-button--inline" (click)="textClicked()">
        {{actionableText}}
      </button>
    }
  </div>
}
@if (isVisibleDeepLinkMsg) {
  <div class="ngx-data-table__deep-link-message-block">
    {{errorText}} <button type="button" class="cfa-plain-button cfa-plain-button--inline" (click)="onClickDeepLinkMsg()">{{deepLinkMessage}}</button>
  </div>
}